<div class="ds-c-title-bar">
  <div class="ds-c-title-bar__section--align-left"></div>
  <div class="ds-c-title-bar__section--align-center">
    <h1 class="app-title">{{ titleKey | translate }}</h1>
  </div>
  <div class="ds-c-title-bar__section--align-right"></div>
</div>
